<div class="dropdown" [class.dropdown__disabled]="disabled" [ngClass]="{'relative': isRelative}">
  <label *ngIf="labelText">{{ labelText }}</label>
  <div class="btn-dropdown" [ngStyle]="{'height': inputHeight}" (click)="openList()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <span class="title" [class.title__colorText]="textTitle && !textTitle.length">{{ textTitle && textTitle.length ? textTitle : placeholder }}</span>
    <ul class="icon-action">
      <li class="icon-link">
        <a class="icon" (click)="clearTitle($event)" *ngIf="(textTitle && textTitle.length > 0) && !disabled">
          <img src="../../../../assets/svgs/i_closed.svg" alt="Limpar">
        </a>
      </li>
      <li class="icon-link" [ngClass]="{'rotate': showList && listItems.length }">
        <a class="icon">
          <svg width="14" height="8" viewBox="0 0 14 8">
            <path d="M6.99928 5.172L11.9493 0.222L13.3633 1.636L6.99928 8L0.635281 1.636L2.04928 0.221999L6.99928 5.172Z" fill="#6F6F6F"/>
          </svg>          
        </a>
      </li>
    </ul>
  </div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="showList && listItems.length"
    [cdkConnectedOverlayMinWidth]="elHeight">
  <div class="list-dropdown">
    <div class="search-input" *ngIf="listItems.length > sizeList && showSearch">
      <input 
        type="text" class="form-control" 
        placeholder="Buscar"
        autofocus="showList" [(ngModel)]="text" 
        (keydown.enter)="searchData()"
        (keydown)="downList($event)"
        (input)="searchInput($event.target.value)">
      <button class="btn-search" (click)="searchData()">
        <img src="../../../../assets/svgs/search.svg" alt="Busca">
      </button>
    </div>
    <ul class="list-group" [ngStyle]="{'height': height + 'px'}" >
      <li class="list-group-item" 
        *ngFor="let item of (listItems | dropdown: { text: text, type: field }); let i = index" 
        (click)="sendText(item)"
        [ngClass]="{'downRow': index === i }">
        <a class="list-action">{{ typeValidator(item) }} <span *ngIf="item[textOptions.field]">{{ item[textOptions.field] === textOptions.equal ? (' - ' + textOptions.alternative) : (' - ' + textOptions.default) }}</span></a>
      </li>
    </ul>
  </div>
</ng-template>
</div>
<div class="backdrop" (click)="this.showList = false" *ngIf="showList"></div>